import {
	getNotificationBySlug,
	getNotifications,
	getStats,
	newNotification,
	updateNotification,
} from '@/services/community/contents/notifications'

export default {
	namespaced: true,
	state: {
		notificationList: {
			meta: {
				total: 0,
			},
		},

		notificationStatus: 'init',
		notificationStats: [],
		notificationStatStatus: 'pending',
		notification: {},
	},
	getters: {
		getNotification(state) {
			return state.notification
		},
		getNotificationList(state) {
			return state.notificationList
		},
		getNotificationStatus(state) {
			return state.notificationStatus
		},
		getNotificationStats(state) {
			return state.notificationStats
		},
		getNotificationStatStatus(state) {
			return state.notificationStatStatus
		},
	},
	mutations: {
		SET_NOTIFICATION(state, value) {
			state.notification = value
		},
		SET_NOTIFICATION_LIST(state, value) {
			state.notificationList = value
		},
		SET_NOTIFICATION_STATUS(state, value) {
			state.notificationStatus = value
		},
		SET_NOTIFICATION_STATS(state, value) {
			state.notificationStats = value
		},
		SET_NOTIFICATION_STAT_STATUS(state, value) {
			state.notificationStatStatus = value
		},
	},
	actions: {
		async fetchNotifications({ commit }, params) {
			commit('SET_NOTIFICATION_STATUS', 'pending')
			commit('SET_NOTIFICATION_LIST', {
				meta: {
					total: 0,
				},
			})
			try {
				const { data } = await getNotifications(params)
				commit('SET_NOTIFICATION_STATUS', 'init')
				commit('SET_NOTIFICATION_LIST', data)
				return data
			} catch (error) {
				commit('SET_NOTIFICATION_STATUS', 'init')
				throw error
			}
		},

		async fetchStats({ commit }, params) {
			commit('SET_NOTIFICATION_STATS', [])
			commit('SET_NOTIFICATION_STAT_STATUS', 'pending')
			try {
				const { data } = await getStats(params)
				commit('SET_NOTIFICATION_STAT_STATUS', 'init')
				commit('SET_NOTIFICATION_STATS', data)
				return data
			} catch (error) {
				commit('SET_NOTIFICATION_STAT_STATUS', 'init')
				throw error
			}
		},
		async saveNotification({ commit }, params) {
			commit('SET_NOTIFICATION_STATUS', 'pending')
			try {
				const { data } = await newNotification(params)
				commit('SET_NOTIFICATION_STATUS', 'init')
				return data
			} catch (error) {
				commit('SET_NOTIFICATION_STATUS', 'init')
				throw error
			}
		},
		async updateNotification({ commit }, params) {
			commit('SET_NOTIFICATION_STATUS', 'pending')
			try {
				const { data } = await updateNotification(params)
				commit('SET_NOTIFICATION_STATUS', 'init')
				return data
			} catch (error) {
				commit('SET_NOTIFICATION_STATUS', 'init')
				throw error
			}
		},
		async fetchNotificationBySlug({ commit }, params) {
			commit('SET_NOTIFICATION_STATUS', 'pending')
			try {
				const { data } = await getNotificationBySlug(params)
				commit('SET_NOTIFICATION_STATUS', 'init')
				commit('SET_NOTIFICATION', data)
				return data
			} catch (error) {
				commit('SET_NOTIFICATION_STATUS', 'init')
				throw error
			}
		},
	},
}
